import { travelActions } from '../config/actions';

const defaultState = {
  isLoading: null,
  data: [],
  created: false,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case travelActions.TRAVELS_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || [],
        created: state.created,
        error: null
      };
    case travelActions.TRAVELS_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        created: false,
        error: action.error
      };
    case travelActions.TRAVELS_NEW:
      return {
        ...state,
        isLoading: false,
        data: [action.data, ...state.data],
        created: true,
        error: null
      };
    case travelActions.TRAVELS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: false,
        error: null
      };
    case travelActions.TRAVELS_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        created: false,
        error: null
      };
    default:
      return state;
  }
};
